import { ButtonProps as MuiButtonProps } from '@mui/material';

import {
  CircularProgressStyled,
  LabelStyled,
  LoaderWrapperStyled,
  PrimaryButtonStyled,
  SecondaryButtonStyled,
  TertiaryButtonStyled,
} from './ButtonStyled';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

export interface ButtonProps extends Omit<MuiButtonProps, 'variant'> {
  fullWidth?: boolean;
  endIcon?: JSX.Element;
  label: string;
  startIcon?: JSX.Element;
  onClick?: () => void;
  variant: ButtonVariant;
  testId?: string;
  isLoading?: boolean;
}

export const Button = ({
  label,
  onClick,
  testId,
  variant,
  isLoading,
  disabled,
  startIcon,
  endIcon,
  ...props
}: ButtonProps) => {
  const commonProps = {
    'data-testid': testId,
    disableFocusRipple: true,
    onClick,
    disabled: disabled || isLoading,
    $isLoading: isLoading,
    $isStartIconVisible: Boolean(startIcon),
    $isEndIconVisible: Boolean(endIcon),
    startIcon,
    endIcon,
  };

  const buttonContent = (
    <>
      <LabelStyled>{label}</LabelStyled>
      {isLoading && (
        <LoaderWrapperStyled
          $isStartIconVisible={commonProps.$isStartIconVisible}
          $isEndIconVisible={commonProps.$isEndIconVisible}
        >
          <CircularProgressStyled size="1.6rem" thickness={6} />
        </LoaderWrapperStyled>
      )}
    </>
  );

  switch (variant) {
    case 'primary':
      return (
        <PrimaryButtonStyled variant="contained" {...commonProps} {...props}>
          {buttonContent}
        </PrimaryButtonStyled>
      );
    case 'secondary':
      return (
        <SecondaryButtonStyled variant="outlined" {...commonProps} {...props}>
          {buttonContent}
        </SecondaryButtonStyled>
      );
    case 'tertiary':
      return (
        <TertiaryButtonStyled variant="text" {...commonProps} {...props}>
          {buttonContent}
        </TertiaryButtonStyled>
      );
  }
};
